/**
 * Matriz de features por código de plano (espelha PlanoSaasService no backend).
 */

export const PLAN_CODES = {
  FREE: 'FREE',
  START: 'START_VERIFICADO',
  PRO: 'PRO_VERIFICADO',
  CORPORATIVO: 'CORPORATIVO'
}

export function normalizePlanoCodigo(codigo) {
  if (!codigo || String(codigo).trim() === '') return PLAN_CODES.FREE
  const n = String(codigo).trim().toUpperCase()
  if (n === 'START' || n === 'NITRO') return PLAN_CODES.START
  if (n === 'PRO' || n === 'NITRO_PLUS' || n === 'NITRO PLUS') return PLAN_CODES.PRO
  if (n === 'ENTERPRISE' || n === 'CORPORATIVO_CONTATO') return PLAN_CODES.CORPORATIVO
  return n
}

export function isPlanoIn(codigo, ...allowed) {
  const normalized = normalizePlanoCodigo(codigo)
  return allowed.some((a) => normalizePlanoCodigo(a) === normalized)
}

/** Defaults alinhados ao backend (FREE) */
const DEFAULT_FEATURES = {
  agenda: false,
  kanban: true,
  taskHistoria: false,
  taskInformacoes: true,
  taskChecklist: true,
  taskAnexos: false,
  taskCor: true,
  taskFinanceiro: false,
  taskProcesso: true,
  taskTags: true,
  taskUsuariosAtribuidos: true,
  taskControleAtividade: false,
  taskAgendamento: false,
  taskHistoricoChat: false,
  crmRelatorios: false,
  crmWhatsapp: false,
  crmHistoricoChat: false,
  crmInformacoesContato: false,
  crmInformacoesNegocio: false,
  crmOrigemLead: false,
  crmCorLead: false,
  crmUsuariosAtribuidos: false,
  crmAgendamento: false,
  crmTags: false,
  crmAnexos: false,
  taskEditLayout: false,
  customForms: false,
  kanbanPreviewMenu: false,
  permissionGroups: false,
  servicosClientes: false,
  servicosAgenda: false,
  servicosFinanceiro: false,
  servicosHistoricoChat: false,
  servicosWhatsapp: false,
  servicosFormularioAgendamento: false,
  servicosTags: false,
  servicosAnexos: false
}

export function getPlanFeaturesFromApi(featuresMap) {
  if (!featuresMap || typeof featuresMap !== 'object') {
    return { ...DEFAULT_FEATURES }
  }
  return { ...DEFAULT_FEATURES, ...featuresMap }
}

export function hasPlanFeature(features, featureKey) {
  if (!features) return false
  return features[featureKey] === true
}
